import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pane" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "region" }
const _hoisted_4 = { "data-type": "province" }
const _hoisted_5 = { "data-type": "province" }
const _hoisted_6 = { "data-type": "province" }

import { ref, onMounted, reactive, watch } from "vue"
import { getSysLocation } from "@/utils/api"

const itemHeight = 40

export default /*@__PURE__*/_defineComponent({
  __name: 'address',
  props: {
    type: {
        type: Number,
        default: 1,
    },
    aid: {
        type: Number,
        default: 0,
    },
    show: {
        type: Boolean,
        default: false,
    },
},
  emits: ['result'],
  setup(__props, { emit: __emit }) {

const props = __props
watch(() => props.show, (val) => {
    state.isShow = val
})

const emit = __emit
const state = reactive({
    isShow: props.show,
})

const items = ref<LocationItem[]>([])
const province = ref<LocationItem | undefined>(undefined)
const city = ref<LocationItem | undefined>(undefined)
const country = ref<LocationItem | undefined>(undefined)
const getLocation = async () => {
    const rsp = await getSysLocation(props.type, props.aid)
    if (rsp.result == 0) {
        items.value = rsp.data.items
        if (items.value.length > 0) {
            onProvince(items.value[0])
        }
    }
}
const onProvince = (item: LocationItem) => {
    province.value = item
    if (item.childs.length > 0) {
        onCity(item.childs[0])
        setTimeout(() => {
            onWheel('city')
        }, 0)
    }
}
const onCity = (item: LocationItem) => {
    city.value = item
    if (item.childs.length > 0) {
        onCountry(item.childs[0])
        setTimeout(() => {
            onWheel('country')
        }, 0)
    }
}
const onCountry = (item: LocationItem) => {
    country.value = item
    console.log(province.value?.name, city.value?.name, item.name)
}
const onOk = () => {
    // state.isShow = false
    const result: LocationItem[] = []
    if (province.value) {
        result.push(province.value)
    }
    if (city.value) {
        result.push(city.value)
    }
    if (country.value) {
        result.push(country.value)
    }
    emit('result', {
        success: true,
        data: result,
    })
}
const onClickClose = () => {
    // state.isShow = false
    emit('result', {
        success: false,
    })
}
onMounted(() => {
    console.log({ props })
    setTimeout(() => {
        getLocation()
    }, 300)
})

let scrollTimeout = 0
const onWheel = (clsName: 'province' | 'city' | 'country') => {
    if (scrollTimeout > 0) {
        clearTimeout(scrollTimeout)
    }
    scrollTimeout = setTimeout(() => {
        scrollTimeout = 0
        afterWheel(clsName)
    }, 100);
}
const afterWheel = (clsName: 'province' | 'city' | 'country') => {
    const ele = document.getElementsByClassName(clsName)[0]
    if (ele) {
        const top = ele.scrollTop
        const offset = top % itemHeight
        var newTop = 0
        if (offset > itemHeight / 2) {
            newTop = parseInt((0.5 + top / 40).toFixed(0))
        } else {
            newTop = parseInt((top / 40).toFixed(0))
        }
        console.log('afterScroll', newTop, offset, top, clsName)
        ele.scrollTo({
            top: newTop * itemHeight
        })
        if (clsName == 'province') {
            onProvince(items.value[newTop])
        }
        if (clsName == 'city') {
            const childs = province.value?.childs || []
            if (childs.length > newTop) {
                onCity(childs[newTop])
            }
        }
        if (clsName == 'country') {
            const childs = city.value?.childs || []
            if (childs.length > newTop) {
                // 设置 country 的值
                onCountry(childs[newTop])
            }
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dialog",
    style: _normalizeStyle({ display: state.isShow ? 'flex' : 'none' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickClose()))
        }, "取消"),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text" }, "选择区域", -1)),
        _createElementVNode("div", {
          class: "btn",
          onClick: onOk
        }, "确认")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "wheel province",
          onScroll: _cache[1] || (_cache[1] = ($event: any) => (onWheel('province')))
        }, [
          _createElementVNode("ul", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "space" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.name), 1))
            }), 128)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "space" }, null, -1))
          ])
        ], 32),
        _createElementVNode("div", {
          class: "wheel city",
          onScroll: _cache[2] || (_cache[2] = ($event: any) => (onWheel('city')))
        }, [
          _createElementVNode("ul", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "space" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(province.value?.childs, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.name), 1))
            }), 128)),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "space" }, null, -1))
          ])
        ], 32),
        _createElementVNode("div", {
          class: "wheel country",
          onScroll: _cache[3] || (_cache[3] = ($event: any) => (onWheel('country')))
        }, [
          _createElementVNode("ul", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "space" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(city.value?.childs, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.name), 1))
            }), 128)),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "space" }, null, -1))
          ])
        ], 32)
      ]),
      (state.isShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onScroll: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
            class: "shadow"
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("div", { class: "item shadow-top" }, null, -1),
            _createElementVNode("div", { class: "lines" }, null, -1),
            _createElementVNode("div", { class: "item shadow-bottom" }, null, -1)
          ]), 32))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (onClickClose()))
    })
  ], 4))
}
}

})